/* global $ */ /* eslint-disable-line */
import UserFilter from './drawUserFilter.js'
import pipeService from '../../service/pipeService'
import dataService from '../../service/dataService.js' /* eslint-disable-line */
import VideoView from '../VideoView/VideoView.vue'

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import globalConfig from '../../service/globalConfig.js'


export default {
    name: 'UserFilter',
    components: {
        VideoView,
        VueSlider,
    },
    props: {
        videoId: String,
        videoData: Object
    },
    data() {
        return {
            // drop downs for videos
            selected: '',
            options: [
                { text: 'apparently_you_cannot_pretend_you_are_a_cop', value: 'apparently_you_cannot_pretend_you_are_a_cop' },
                { text: 'this_is_what_happens_when_you_reply_to_spam_email', value: 'this_is_what_happens_when_you_reply_to_spam_email' },
            ],
            ////////////////////////
            containerId: 'userfilterContainer',
            explorationviewdata: {},
            storyviewdata: {},
            showVideoFlag: false,
            featureData: [],
            // feature filter val.
            repval: [0, 100],
            repmax: 100,
            repmarks: [],
            disconval: [0, 100],
            disconmax: 100,
            disconmarks: [],
            polval: [0, 100],
            polmax: 100,
            polmarks: [],
            subval: [0, 100],
            subjmax: 100,
            subjmarks: [],
            allival: [0, 100],
            allimax: 100,
            allimarks: [],
            rhyval: [0, 100],
            rhymax: 100,
            rhymarks: [],
            loudval: [0, 100],
            loudmax: 100,
            loudmarks: [],
            softval: [0, 100],
            softmax: 100,
            softmarks: [],
            stressval: [0, 100],
            stressmax: 100,
            stressmarks: [],
            pauseval: [0, 100],
            pausemax: 100,
            pausemarks: [],
            fastval: [0, 100],
            fastmax: 100,
            fastmarks: [],
            slowval: [0, 100],
            slowmax: 100,
            slowmarks: [],
            // --- ADD: context length
            contxtval: [0, 100],
            contxtmax: 100,
            contxtmarks: [],
            // --- ADD: textual feature freq.
            textualval: [0, 100],
            textualmax: 100,
            textualmarks: [],
            // --- ADD: audio feature freq.
            audioval: [0, 100],
            audiomax: 100,
            audiomarks: [],
        }
    },
    computed: {
        filterdata: function() {
            return {
                "repetition": this.repval,
                "disconnection": this.disconval,
                "polarity": this.polval,
                "subjectivity": this.subval,
                "alliterations": this.allival,
                "rhymes": this.rhyval,
                "louder": this.loudval,
                "softer": this.softval,
                "stress": this.stressval,
                "pause": this.pauseval,
                "faster": this.fastval,
                "slower": this.slowval,
                "contextlens": this.contxtval,
                "textualval": this.textualval,
                "audioval": this.audioval,
            };
        }
    },
    watch: {
        selected: function(selected){
            if(selected.length>0){
                console.log("selected item: ", selected);
                pipeService.emitSelectVideo(selected);
            }
        },
        filterdata: function() {
            pipeService.emitSubmitFilter({
                "repetition": this.repval,
                "disconnection": this.disconval,
                "polarity": this.polval,
                "subjectivity": this.subval,
                "alliterations": this.allival,
                "rhymes": this.rhyval,
                "louder": this.loudval,
                "softer": this.softval,
                "stress": this.stressval,
                "pause": this.pauseval,
                "faster": this.fastval,
                "slower": this.slowval,
                "contextlens": this.contxtval,
                "textualval": this.textualval,
                "audioval": this.audioval,
            });
        },
        showVideoFlag: function(showVideoFlag) {
            if (showVideoFlag) {
                $('#featurefilter').css("height", "280px");
                $("#originalvideo").show();
                $("#videoPlayerContainer").show();
            } else {
                $('#featurefilter').css("height", "520px");
                $("#originalvideo").hide();
                $("#videoPlayerContainer").hide();
            }
        },

    },
    mounted: function() {
        const _this = this;
        this.drawUserFilter = new UserFilter(this.containerId);

        console.log("selected items");
        // --- set initial selected item
        _this.selected = "apparently_you_cannot_pretend_you_are_a_cop";

        // --- on handle exploration video post
        pipeService.onSpeechData(humordata => {

            let humorskills = humordata[0];
            let contextLens = humordata[1]; /* eslint-disable-line */

            // ---
            console.log("receive speech data:", humorskills, contextLens);
            console.log("--- receive speech data in the UserFilter ---");
            // --- receive humorskills
            this.humorskills = humorskills;
            let humorskillsType = globalConfig.humorskillsType;
            let skillsDistr = {};
            humorskillsType.map(function(ht) {
                skillsDistr[ht] = [];
            });
            /////////////////////////////////////////////////////
            // --- update sentence skills distributions
            /////////////////////////////////////////////////////

            Object.keys(humorskills).map(function(k) {
                let segSkills = humorskills[k];
                Object.keys(segSkills).map(function(skill) {
                    skillsDistr[skill].push(segSkills[skill]);
                });
            });
            // console.log("humor distribution:", skillsDistr);
            // --- compare (sort functions)
            const _this = this;
            Object.keys(skillsDistr).map(function(k) {
                skillsDistr[k].sort(globalConfig.compare);
                let maxvval = Math.max.apply(null, skillsDistr[k])
                let valarr = skillsDistr[k];
                let meanarr = valarr[Math.floor(valarr.length / 2)];
                // valarr.reduce((previous, current) => current += previous) / valarr.length;
                let q1arr = valarr[Math.floor(valarr.length / 4)];
                let q3arr = valarr[Math.floor(valarr.length / 4 * 3)];
                let markarr = [0, q1arr.toFixed(0), q3arr.toFixed(0), meanarr.toFixed(0), maxvval.toFixed(0)].filter(globalConfig.onlyUnique);
                // console.log("calculated val", valarr, maxvval, meanarr, q1arr, q3arr);
                if (k == "repetition") {
                    _this.$nextTick(() => {
                        _this.$refs.repslider.setValue([0, maxvval]);
                        _this.repmax = maxvval;
                        _this.repmarks = markarr.sort(globalConfig.compare);
                        // console.log("--- repetition: ---", _this.repmarks);
                    });
                } else if (k == "disconnection") {
                    _this.$nextTick(() => {
                        _this.$refs.disconslider.setValue([0, maxvval]);
                        _this.disconmax = maxvval;
                        _this.disconmarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "polarity") {
                    _this.$nextTick(() => {
                        _this.$refs.polslider.setValue([0, maxvval]);
                        _this.polmax = maxvval;
                        _this.polmarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "subjectivity") {
                    _this.$nextTick(() => {
                        _this.$refs.subjslider.setValue([0, maxvval]);
                        _this.subjmax = maxvval;
                        _this.subjmarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "alliterations") {
                    _this.$nextTick(() => {
                        _this.$refs.allislider.setValue([0, maxvval]);
                        _this.allimax = maxvval;
                        _this.allimarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "rhymes") {
                    _this.$nextTick(() => {
                        _this.$refs.rhyslider.setValue([0, maxvval]);
                        _this.rhymax = maxvval;
                        _this.rhymarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "louder") {
                    _this.$nextTick(() => {
                        _this.$refs.loudslider.setValue([0, maxvval]);
                        _this.loudmax = maxvval;
                        _this.loudmarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "softer") {
                    _this.$nextTick(() => {
                        _this.$refs.softslider.setValue([0, maxvval]);
                        _this.softmax = maxvval;
                        _this.softmarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "stress") {
                    _this.$nextTick(() => {
                        _this.$refs.stresslider.setValue([0, maxvval]);
                        _this.stressmax = maxvval;
                        _this.stressmarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "pause") {
                    _this.$nextTick(() => {
                        _this.$refs.pauseslider.setValue([0, maxvval]);
                        _this.pausemax = maxvval;
                        _this.pausemarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "faster") {
                    _this.$nextTick(() => {
                        _this.$refs.fastslider.setValue([0, maxvval]);
                        _this.fastmax = maxvval;
                        _this.fastmarks = markarr.sort(globalConfig.compare);
                    });
                } else if (k == "slower") {
                    _this.$nextTick(() => {
                        _this.$refs.slowslider.setValue([0, maxvval]);
                        _this.slowmax = maxvval;
                        _this.slowmarks = markarr.sort(globalConfig.compare);
                    });
                }
            });

            console.log("humor distribution:", skillsDistr, this.$refs.repslider);

            // --- update context lengths

            let contextlenarr = Object.values(contextLens);
            console.log("context length:", contextlenarr);
            contextlenarr.sort(globalConfig.compare);
            let maxvval = Math.max.apply(null, contextlenarr)
            let meanarr = contextlenarr[Math.floor(contextlenarr.length / 2)];
            // contextlenarr.reduce((previous, current) => current += previous) / contextlenarr.length;
            let q1arr = contextlenarr[Math.floor(contextlenarr.length / 4)];
            let q3arr = contextlenarr[Math.floor(contextlenarr.length / 4 * 3)];
            let markarr = [0.0, q1arr.toFixed(1), q3arr.toFixed(1), meanarr.toFixed(1), maxvval.toFixed(1)].filter(globalConfig.onlyUnique);
            this.$nextTick(() => {
                _this.contxtval = [0, maxvval];
                _this.contxtmax = maxvval;
                _this.contxtmarks = markarr;
            });


            // --- update textual/audio features
            let textual_skills = [];
            let audio_skills = [];
            // console.log("(updated) humorskills:", Object.values(humorskills));
            Object.values(humorskills).map(function(sk) {
                let seg_text_skills = 0;
                let seg_audio_skills = 0;
                Object.keys(sk).map(function(skt) {
                    if (globalConfig.textualhumorTypes.indexOf(skt) > -1) {
                        seg_text_skills = seg_text_skills + sk[skt];
                        // textual_skills.push(sk[skt]);
                    } else if (globalConfig.audiohumorTypes.indexOf(skt) > -1) {
                        seg_audio_skills = seg_audio_skills + sk[skt];
                        // audio_skills.push(sk[skt]);
                    }
                });
                // --- text/audio
                textual_skills.push(seg_text_skills);
                audio_skills.push(seg_audio_skills);

            });
            textual_skills.sort(globalConfig.compare);
            audio_skills.sort(globalConfig.compare);

            // text/audio statistics
            let maxvval_audio = Math.max.apply(null, audio_skills)
            let meanarr_audio = audio_skills[Math.floor(audio_skills.length / 2)];
            let q1arr_audio = audio_skills[Math.floor(audio_skills.length / 4)];
            let q3arr_audio = audio_skills[Math.floor(audio_skills.length / 4 * 3)];
            let markarr_audio = [0.0, q1arr_audio.toFixed(1), q3arr_audio.toFixed(1), meanarr_audio.toFixed(1), maxvval_audio.toFixed(1)].filter(globalConfig.onlyUnique);

            let maxvval_text = Math.max.apply(null, textual_skills)
            let meanarr_text = textual_skills[Math.floor(textual_skills.length / 2)];
            let q1arr_text = textual_skills[Math.floor(textual_skills.length / 4)];
            let q3arr_text = textual_skills[Math.floor(textual_skills.length / 4 * 3)];
            let markarr_text = [0.0, q1arr_text.toFixed(1), q3arr_text.toFixed(1), meanarr_text.toFixed(1), maxvval_text.toFixed(1)].filter(globalConfig.onlyUnique);

            this.$nextTick(() => {
                //  --- set audio slider
                _this.audioval = [0, maxvval_audio];
                _this.audiomax = maxvval_audio;
                _this.audiomarks = markarr_audio;
                //  --- set text slider
                _this.textualval = [0, maxvval_text];
                _this.textualmax = maxvval_text;
                _this.textualmarks = markarr_text;
            });

        })

        // --- onclick row tag
        $("#featurefilter .rowgrouped .rowtag").click(function() {
            // tell if rotate before
            let thisicon = $(this).find("i");
            // console.log("this node parent:", thisicon.parents(".rowgrouped"));
            let iconclass = thisicon.attr('class');
            if (iconclass.includes("fa-rotate-180")) {
                // --- remove rotate
                thisicon.removeClass("fa-rotate-180");
                thisicon.parents(".rowgrouped").find(".rowfeature").css("display", "none");
            } else {
                thisicon.addClass("fa-rotate-180");
                thisicon.parents(".rowgrouped").find(".rowfeature").css("display", "flex");
            }
        });

        // --- click on the sentence in Exploration View
        pipeService.onSeekFromTime(t => {
            console.log("SeekTime: ", t);
            _this.showVideoFlag = true;
        });
    },
    methods: {
        showVideo: function() {
            if ($("#userfilterContainer").css("display") != "none") {
                this.showVideoFlag = !this.showVideoFlag
                console.log("show video:", this.showVideoFlag);
            }
        },
        collapseAll: function() {
            $("#featurefilter .rowfeature").css("display", "flex");
            // --- change icons for rowfeatures
            $("#featurefilter .rowgrouped .rowtag").each(function() {
                let thisicon = $(this).find("i");
                let iconclass = thisicon.attr('class');
                if (!iconclass.includes("fa-rotate-180")) {
                    thisicon.addClass("fa-rotate-180");
                }
            })
        },
        foldAll: function() {
            $("#featurefilter .rowfeature").css("display", "none");
            // --- change icons for rowfeatures
            $("#featurefilter .rowgrouped .rowtag").each(function() {
                let thisicon = $(this).find("i");
                let iconclass = thisicon.attr('class');
                if (iconclass.includes("fa-rotate-180")) {
                    thisicon.removeClass("fa-rotate-180");
                }
            })
        },
        // reset all sliderval
        resetAll: function() {
            const _this = this;
            _this.$nextTick(() => {
                _this.repval = [0, _this.repmax];
                _this.disconval = [0, _this.disconmax];
                _this.polval = [0, _this.polmax];
                _this.subval = [0, _this.subjmax];
                _this.allival = [0, _this.allimax];
                _this.rhyval = [0, _this.rhymax];
                _this.loudval = [0, _this.loudmax];
                _this.softval = [0, _this.softmax];
                _this.stressval = [0, _this.stressmax];
                _this.pauseval = [0, _this.pausemax];
                _this.fastval = [0, _this.fastmax];
                _this.slowval = [0, _this.slowmax];
                _this.contxtval = [0, _this.contxtmax];
                _this.textualval = [0, _this.textualmax];
                _this.audioval = [0, _this.audiomax];
            });
        },
        // --- submit filtering
        submitFilter: function() {
            let filterdata = {
                "repetition": this.repval,
                "disconnection": this.disconval,
                "polarity": this.polval,
                "subjectivity": this.subval,
                "alliterations": this.allival,
                "rhymes": this.rhyval,
                "louder": this.loudval,
                "softer": this.softval,
                "stress": this.stressval,
                "pause": this.pauseval,
                "faster": this.fastval,
                "slower": this.slowval,
            };
            console.log("clicked on filtering button!", filterdata);
        }

    }
}